/**
 * Controla la tabla de inspecciones.
 */
CamposExtraDateCtrl.$inject = [];
export default function CamposExtraDateCtrl() {

    var campExtDate = this;
    campExtDate.claseRow = issetAndNotEmpty(campExtDate.claseRow) ? campExtDate.claseRow == 'true' : true;

    if (campExtDate.campoExtra.valor !== null)
        campExtDate.dateValue = moment(campExtDate.campoExtra.valor, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY HH:mm");
    else
        campExtDate.dateValue = '';

    campExtDate.hasError = false;

    campExtDate.validate = function () {

        if (campExtDate.dateValue !== '' && moment(campExtDate.dateValue, "DD/MM/YYYY HH:mm").isValid()) {
            campExtDate.hasError = false;
            campExtDate.campoExtra.valor = moment(campExtDate.dateValue, "DD/MM/YYYY HH:mm").format("YYYY-MM-DD HH:mm");
            campExtDate.campoExtra.changed = true;
        } else {
            campExtDate.hasError = true;
            campExtDate.campoExtra.changed = false;
        }

    };

    campExtDate.borrar = function () {
        campExtDate.dateValue = '';
        campExtDate.campoExtra.valor = null;
        campExtDate.campoExtra.changed = true;
    };
}